export const techniques = {
  conventional: 'Convencional',
  video: 'Vídeo',
  robotic: 'Robótica',
};

export function getName(value) {
  return techniques[value];
}
